import { UPDATE_CURRENT_LINEITEM, UPDATE_LAST_LINEITEM, UPDATE_RECEIVE_TS } from '../actionTypes';

export const station = (
	state = {
		currentLineItem: null,
		lastLineItem: null,
		receiveTs: null,
	},
	action,
) => {
	switch (action.type) {
		case UPDATE_CURRENT_LINEITEM:
			return { ...state, currentLineItem: action.currentLineItem };
		case UPDATE_LAST_LINEITEM:
			return { ...state, lastLineItem: action.lastLineItem };
		case UPDATE_RECEIVE_TS:
			return { ...state, receiveTs: action.payload.receiveTs };
		default:
			return state;
	}
};
